'use strict';

export default function clearForm ($form) {
    return $form
        .find('input, select, textarea')
        .each((idx, el) => {
            let $el = $(el),
                inputType = $el.attr('type');

            if (['radio', 'checkbox'].indexOf(inputType) > 0) {
                $el
                    .removeAttr('checked')
                    .removeAttr('selected');
            } else {
                $el.val('');
            }
        });
}
